// Last modified: 2022/10/27 13:49:12
import ThemeConfiguration, { config } from './ThemeConfiguration.vue';

export { config };
export default ThemeConfiguration;
